import React from 'react'
import classNames from 'classnames'
import './index.scss'

function capitalizeFirstLetter(label?: string): string {
  if (!label) return ''
  return label.charAt(0).toUpperCase() + label.slice(1)
}

function isSimpleText(text: any) {
  return typeof text === 'string' || typeof text === 'number'
}

function LabelText({ label, value, className, capFirstLetter }: { label: string, value?: React.ReactNode | string | number, className?: string, capFirstLetter?: boolean}) {
  if (isSimpleText(label)&&((typeof capFirstLetter == 'undefined')||capFirstLetter)) {
    label = capitalizeFirstLetter(label)
  }
  return (
    <div key={label} className={classNames('label-text', className)}>
      {isSimpleText(label) ? <span><strong>{label}: </strong></span> : label}
      {isSimpleText(value) ? (<span>{value}</span>) : value }
    </div>
  )
}

export default LabelText
